export let favoritesHeaderText = "RPRnjc";
export let favoritesWithAccountNameHeaderText = "xDKXTd";
export default {favoritesHeaderText,favoritesWithAccountNameHeaderText};